export enum ApiErrors_ENUM {
  TooManyDownloads = "TOO_MANY_DOWNLOADS",
  UserAlreadyAddedToAnotherGroup = "USER_ALREADY_ADDED_TO_ANOTHER_GROUP",
  SampleNameAlreadyExists = "SAMPLENAME_ALREADY_EXISTS",
  TrapNameAlreadyExists = "TRAPNAME_ALREADY_EXISTS",
}

export enum AuthErrors_ENUM {
  UserNotFound = "USER_NOT_FOUND",
  EmailAlreadyExists = "EMAIL_ALREADY_EXISTS",
  LoginAlreadyExists = "LOGIN_ALREADY_EXISTS",
  BothAlreadyExists = "BOTH_ALREADY_EXISTS",
  IncorrectPassword = "INCORRECT_PASSWORD",
  AccountNotActive = "ACCOUNT_NOT_ACTIVE",
  VerificationTokenMissing = "VERIFICATION_TOKEN_MISSING",
  IncorrectVerificationToken = "INCORRECT_VERIFICATION_TOKEN",
  RoleNotAllowedToLogin = "ROLE_NOT_ALLOWED_To_LOGIN",
}
